// This component displays the header of the menu preview.

import { Button, Text, Title3 } from "@fluentui/react-components";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MenuPublishedState, StationEditState } from "../../common/commonConstants";
import { confirmDeleteMenu, confirmPublishMenu } from "../../reducers/diningReducer";
import { weekMenuSelector } from "../../selectors/diningSelector";
import { useRestoreFocusOnDialogClose } from "../DialogBox";
import styles from "../../styles/menuPreview.module.css";
import { ModalType } from "../../common/commonConstants";

export interface MenuPreviewHeaderProps {
  cafeName: string;
  serviceHours?: string;
  notificationState: MenuPublishedState | StationEditState | undefined;
}

const MenuPreviewHeaderView = ({ cafeName, serviceHours, notificationState }: MenuPreviewHeaderProps) => {
  const dispatch = useDispatch();
  const weeklyMenu = useSelector(weekMenuSelector);
  const captureTrigger = useRestoreFocusOnDialogClose(ModalType.CONFIRM_PUBLISH_MENU);
  return (
    <div className={styles.menuPreviewHeader}>
      <div
        className={styles.menuPreviewHeader}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <Title3>{cafeName}</Title3>

        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <Button
            appearance="primary"
            onClick={() => {
              captureTrigger();
              dispatch(confirmPublishMenu());
            }}
            disabled={notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY || !weeklyMenu}
          >
            Publish
          </Button>

          <Button
            onClick={() => {
              captureTrigger();
              dispatch(confirmDeleteMenu());
            }}
            disabled={notificationState === MenuPublishedState.CHANGES_PUBLISHED_SUCCESSFULLY || !weeklyMenu}
          >
            Delete
          </Button>
        </div>
      </div>

      {serviceHours && <Text className={styles.serviceHours}>{serviceHours}</Text>}
    </div>
  );
};

export default MenuPreviewHeaderView;
